import React, { Component } from 'react';
import classNames from 'classnames';
import AppTopbar from './AppTopbar';
import { AppMenu } from './AppMenu';
import { Route, Redirect } from 'react-router-dom';
import ScreensHomeForm from "./layout/Form";
import ScreensConfig from "./screens/Config/Config";
import { AppInlineProfile } from "./AppInlineProfile";
import ScreensLoginForm from "./screens/Login/Form";
import ScreensLoginMedicoSolicitanteForm from "./screens/LoginMedicoSolicitante/Form";
import ScreensLoginPacienteForm from "./screens/LoginPaciente/Form";
import ScreensLoginConvenioForm from "./screens/LoginConvenio/Form";
import ScreensAdminLogin from "./screens/AdminLogin/AdminLogin";
import { ServiceLogin } from "./service/Login";
import ScreensLogoutForm from "./screens/Logout/Form";
import { Toast } from 'primereact/toast';
import { ServiceMessage } from "./service/Message";

import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';

import './layout/layout.css';
import './App.css';
import { ServiceConfig } from './service/Config';
import { GaleriaJob } from './components/GaleriaJob/Galeria';

const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route
        {...rest}
        render={(props) => {
            const auth = sessionStorage.getItem('auth');

            // Proteção extra: sem auth, volta pro login
            if (!auth || ServiceLogin.isLoggedIn() === false) {
                return <Redirect to={{ pathname: '/', state: { from: props.location } }} />;
            }

            return <Component {...props} />
        }}
    />
);

const tempoInatividadeOptions = [
    { label: '15 minutos', value: 0, minutos: 15 },
    { label: '30 minutos', value: 1, minutos: 30 },
    { label: '45 minutos', value: 2, minutos: 45 },
    { label: '1 hora', value: 3, minutos: 60 }
];


class App extends Component {

    constructor() {
        super();
        this.state = {
            layoutMode: 'overlay',
            layoutColorMode: 'dark',
            staticMenuInactive: false,
            overlayMenuActive: false,
            mobileMenuActive: false,
            configDB: '',
            tempoInatividade: 0,

        };

        this.onWrapperClick = this.onWrapperClick.bind(this);
        this.onToggleMenu = this.onToggleMenu.bind(this);
        this.onSidebarClick = this.onSidebarClick.bind(this);
        this.onMenuItemClick = this.onMenuItemClick.bind(this);
        this.createMenu();

        window.globalVars = {
            acessoMedicoSolicitante: false
        };
    }

    onWrapperClick(event) {
        if (!this.menuClick) {
            this.setState({
                overlayMenuActive: false,
                mobileMenuActive: false
            });
        }

        this.menuClick = false;
    }

    onToggleMenu(event) {
        this.menuClick = true;

        if (this.isDesktop()) {
            if (this.state.layoutMode === 'overlay') {
                this.setState({
                    overlayMenuActive: !this.state.overlayMenuActive
                });
            }
            else if (this.state.layoutMode === 'static') {
                this.setState({
                    staticMenuInactive: !this.state.staticMenuInactive
                });
            }
        }
        else {
            const mobileMenuActive = this.state.mobileMenuActive;
            this.setState({
                mobileMenuActive: !mobileMenuActive
            });
        }

        event.preventDefault();
    }

    onSidebarClick(event) {
        this.menuClick = true;
        setTimeout(() => { this.layoutMenuScroller.moveBar(); }, 500);
    }

    onMenuItemClick(event) {
        if (!event.item.items) {
            this.setState({
                overlayMenuActive: false,
                mobileMenuActive: false
            })
        }
    }

    createMenu() {
        this.menu = [
            { label: 'Exames', icon: 'pi pi-fw pi-calendar', command: () => { window.location = '#/portal' } },
            // {label: 'Contato', icon: 'pi pi-fw pi-plus', command: () => {window.location = '#/contato'}},
        ];
    }

    addClass(element, className) {
        if (element.classList)
            element.classList.add(className);
        else
            element.className += ' ' + className;
    }

    removeClass(element, className) {
        if (element.classList)
            element.classList.remove(className);
        else
            element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
    }

    isDesktop() {
        return window.innerWidth > 1024;
    }

    componentDidUpdate() {
        if (this.state.mobileMenuActive)
            this.addClass(document.body, 'body-overflow-hidden');
        else
            this.removeClass(document.body, 'body-overflow-hidden');
    }

    handleMessagesRef(el) {
        ServiceMessage.register(el);
    }


//#region Inativação a cada Um minuto

    inactivityTimeout = null;
    inactivityLimit = 60000 * 10;


    // startInactivityTimer
    startInactivityTimer() {
        const index = this.state.tempoInatividade || 0;
        const opt = tempoInatividadeOptions[index] || tempoInatividadeOptions[0];
        const minutos = opt.minutos;

        this.inactivityLimit = minutos * 60000;
        this.clearInactivityTimer();

        this.inactivityTimeout = setTimeout(() => {
            sessionStorage.setItem(
                'logoutMessage',
                'Você foi desconectado devido à inatividade.'
            );

            ServiceLogin.logout();

            setTimeout(() => {
                window.location = "#/logout";
            }, 500);
        }, this.inactivityLimit);
    }





    clearInactivityTimer() {
        if (this.inactivityTimeout) {
            clearTimeout(this.inactivityTimeout);
        }
    }

    resetInactivityTimer = () => {
        if (ServiceLogin.isLoggedIn()) {
            const tempoAtual = this.state.tempoInatividade || 0;
            this.startInactivityTimer(tempoAtual);
        }
    }


    componentDidMount() {
        // Adiciona eventos para detectar interação
        window.addEventListener('mousemove', this.resetInactivityTimer);
        window.addEventListener('mousedown', this.resetInactivityTimer);
        window.addEventListener('keypress', this.resetInactivityTimer);
        window.addEventListener('scroll', this.resetInactivityTimer);
        window.addEventListener('touchstart', this.resetInactivityTimer);

        if (ServiceLogin.isLoggedIn()) {
            this.getConfig().then((config) => {
                const tempoAtual = this.state.tempoInatividade || 0;
                this.startInactivityTimer(tempoAtual);
            });
        }
    }



    componentWillUnmount() {
        window.removeEventListener('mousemove', this.resetInactivityTimer);
        window.removeEventListener('mousedown', this.resetInactivityTimer);
        window.removeEventListener('keypress', this.resetInactivityTimer);
        window.removeEventListener('scroll', this.resetInactivityTimer);
        window.removeEventListener('touchstart', this.resetInactivityTimer);
        this.clearInactivityTimer();
    }

    getConfig() {
        console.error("COLETANDO CONFIGURACAO INICIAL");
        try {
            this.serviceConfig = new ServiceConfig();

            return this.serviceConfig.GetConfig()
                .then(res => {
                    let arr = [];

                    if (Array.isArray(res.data)) {
                        arr = res.data;
                    } else if (Array.isArray(res)) {
                        arr = res;
                    } else if (typeof res.data === "string") {
                        arr = JSON.parse(res.data);
                    } else if (typeof res === "string") {
                        arr = JSON.parse(res);
                    } else {
                        console.error("Formato inesperado de resposta:", res);
                        return {};
                    }

                    const config = {};
                    arr.forEach(item => {
                        config[item.Key] = {
                            id: item.Id,
                            value: item.Value
                        };
                    });

                    console.log("Config mapeada:", config);

                    this.setState({
                        configDB: config,
                        tempoInatividade: (() => {
                            const raw = config['TEMPO_INATIVIDADE_PORTAL']?.value;
                            if (raw === undefined) return 0;

                            if (!isNaN(raw)) {
                                return parseInt(raw, 10);
                            }
                            const found = tempoInatividadeOptions.find(opt => opt.label === raw);
                            return found ? found.value : 0;
                        })()
                    });


                    return config;
                })
                .catch(err => {
                    console.error("Erro no GetConfig:", err);
                    return {};
                });
        } catch (err) {
            console.error("Erro catch getConfig:", err);
            return Promise.resolve({});
        }
    }




//#endregion

    render() {

        let wrapperClass = classNames('layout-wrapper', {
            'layout-overlay': this.state.layoutMode === 'overlay',
            'layout-static': this.state.layoutMode === 'static',
            'layout-static-sidebar-inactive': this.state.staticMenuInactive && this.state.layoutMode === 'static',
            'layout-overlay-sidebar-active': this.state.overlayMenuActive && this.state.layoutMode === 'overlay',
            'layout-mobile-sidebar-active': this.state.mobileMenuActive
        });
        let sidebarClassName = classNames("layout-sidebar", { 'layout-sidebar-dark': this.state.layoutColorMode === 'dark' });

        let topbar = ServiceLogin.isLoggedIn()
            && window.location.hash !== '#/Jobs'
            ? (<AppTopbar onToggleMenu={this.onToggleMenu} />)
            : (<div></div>);

        let sideBar = ServiceLogin.isLoggedIn() && window.location.hash !== '#/Jobs'
            ? (
                <div ref={(el) => this.sidebar = el} className={sidebarClassName} onClick={this.onSidebarClick}>

                </div>
            )
            : (<div></div>);

        return (

            <div className={wrapperClass} onClick={this.onWrapperClick}>

                <Toast ref={this.handleMessagesRef.bind(this)} className="custom-toast" />

                {topbar}

                <div>
                    <Route exact path="/" render={(props) => {
                        const auth = sessionStorage.getItem('auth');
                        if (auth && ServiceLogin.isLoggedIn()) {
                            return <Redirect to="/portal" />;
                        }
                        return <ScreensLoginForm {...props} />;
                    }} />

                    <Route exact path="/medico" render={() => (
                        <Redirect to="/" />
                    )} />
                    <Route exact path="/medicosolicitante" render={() => (
                        <Redirect to="/" />
                    )} />
                    <Route exact path="/convenio" render={() => (
                        <Redirect to="/" />
                    )} />

                    <Route exact path="/logout" component={ScreensLogoutForm} />
                    <PrivateRoute path="/portal" component={ScreensHomeForm} />
                    <PrivateRoute exact path="/Jobs" component={GaleriaJob} />
                    <Route exact path="/admin" component={ScreensAdminLogin} />
                    <PrivateRoute path="/admin/config" component={ScreensConfig} />
                </div>
                <div className="layout-mask"></div>

            </div>
        );
    }
}

export default App;